import React from 'react';
import { ArrowRight, BadgeHelp, CreditCard, LifeBuoy } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const workplaceCards = [
  {
    title: 'Billing',
    description: 'Payments, subscription, and billing information for your account.',
    href: '/billing',
    icon: CreditCard,
  },
  {
    title: 'PT Assessment Guide',
    description: 'Assessment resources, structure, and guidance for your PT journey.',
    href: '/pt-assessment',
    icon: BadgeHelp,
  },
  {
    title: 'Support Resources',
    description: 'Need help? Reach support resources and guidance quickly.',
    href: '/help',
    icon: LifeBuoy,
  },
];

export const WorkplacePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-5xl p-4 lg:p-6">
      <div className="mb-6 rounded-3xl border border-orange-100 bg-gradient-to-br from-white to-orange-50/50 p-6 shadow-sm">
        <p className="mb-2 text-sm font-semibold uppercase tracking-wide text-orange-500">Workplace</p>
        <h1 className="text-2xl font-semibold text-gray-900 lg:text-3xl">Your Workplace</h1>
        <p className="mt-2 max-w-2xl text-sm text-gray-600 lg:text-base">
          Tools and support for your PT journey, organized in one calm and easy-to-use workspace.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {workplaceCards.map((card) => {
          const Icon = card.icon;
          return (
            <button
              key={card.href}
              onClick={() => navigate(card.href)}
              className="group rounded-3xl border border-gray-200 bg-white p-5 text-left shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-orange-200 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500"
            >
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-orange-50 text-orange-600">
                <Icon className="h-6 w-6" />
              </div>
              <h2 className="text-lg font-semibold text-gray-900">{card.title}</h2>
              <p className="mt-2 text-sm leading-6 text-gray-600">{card.description}</p>
              <div className="mt-5 flex items-center gap-2 text-sm font-medium text-orange-600">
                <span>Open</span>
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default WorkplacePage;
